module.exports = __webpack_public_path__ + "tokenPay.85db6241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/tokenPay.png
// module id = 357
// module chunks = 0